import { render, staticRenderFns } from "./InvestmentsAllocation.vue?vue&type=template&id=0b93fdd2&scoped=true"
import script from "./InvestmentsAllocation.vue?vue&type=script&lang=js"
export * from "./InvestmentsAllocation.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsAllocation.vue?vue&type=style&index=0&id=0b93fdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93fdd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
